import { useSelectedStore } from "@src/store/reducers/CartSlice/selectors";
import { ProductItem } from "@src/hooks/query/useAllProduct";
import { useCallback } from "react";
import { ProductApiData } from "@src/interface/Product";
import useCartModelChange from "@src/backbone/hooks/useCartModelChange";

const useShowProductPrice = () => {
  const store = useSelectedStore();
  const [, cart] = useCartModelChange("change");

  const hasDeliveryAddress = !!cart.getAddressDelivery();
  const hasStore = !!store || !!cart.getStore();
  const hasLocation = hasDeliveryAddress || hasStore;

  const canShowProductPrice = useCallback(
    (product?: ProductApiData | ProductItem): boolean => hasLocation,
    [hasLocation]
  );

  return {
    canShowProductPrice,
    hasStore,
    store,
    hasDeliveryAddress,
    hasLocation,
  };
};

export default useShowProductPrice;
